import { Model, Module, Mutation, Action, ApiClient, store } from './helpers'
import { DateTime } from 'luxon'
import { Messages } from '../models'

export interface LocationModel {
  id: number
  nickname: string
  full_address: string
  street_address: string
  deleted_at?: string
  time_zone?: string
}

@Module
export class LocationModule extends Model<LocationModel> {
  activeId: number = null
  isLoading = false

  get activeLocation() { return this.entitiesById[this.activeId] || null }

  @Action async GET_LOCATIONS() {
    this.startLoading(true)
    const { data } = await ApiClient.get('/my_client/locations.json')
    this.STORE_ENTITIES(data.locations.filter((location: LocationModel) => !location.deleted_at))
    this.startLoading(false)
  }

  @Action RESET() {
    this.UNSET_ACTIVE_LOCATION()
  }

  @Mutation SET_ACTIVE_LOCATION_ID(id: number) {
    this.activeId = id
    Messages.RECALCULATE_MESSAGES_FOR_CURRENT_LOCATION()
  }

  @Mutation UNSET_ACTIVE_LOCATION() {
    this.activeId = 0
  }

  @Mutation startLoading(isLoading: boolean = true) {
    this.isLoading = isLoading
  }

  calculateTime() {
    if (this.activeLocation && this.activeLocation.time_zone) {
      return DateTime.local().setZone(this.activeLocation.time_zone).toFormat('T')
    }

    return DateTime.local().toFormat('T')
  }
}

export const Locations = new LocationModule({ store, name: 'Locations' })
